/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type QrCodeList_lists$ref = any;
export type QrCodeListQueryVariables = {||};
export type QrCodeListQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: QrCodeList_lists$ref
  |}
|};
export type QrCodeListQuery = {|
  variables: QrCodeListQueryVariables,
  response: QrCodeListQueryResponse,
|};
*/


/*
query QrCodeListQuery {
  lists {
    ...QrCodeList_lists
    id
  }
}

fragment QrCodeCell_qrCode on QrCode {
  id
  createdAt
  sign
}

fragment QrCodeList_lists on Lists {
  id
  qrCodes(first: 100) {
    edges {
      node {
        id
        ...QrCodeCell_qrCode
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QrCodeListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QrCodeList_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QrCodeListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "QrCodeConnection",
            "kind": "LinkedField",
            "name": "qrCodes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QrCodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QrCode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sign",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "qrCodes(first:100)"
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "QrCodeList_qrCodes",
            "kind": "LinkedHandle",
            "name": "qrCodes"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "QrCodeListQuery",
    "operationKind": "query",
    "text": "query QrCodeListQuery {\n  lists {\n    ...QrCodeList_lists\n    id\n  }\n}\n\nfragment QrCodeCell_qrCode on QrCode {\n  id\n  createdAt\n  sign\n}\n\nfragment QrCodeList_lists on Lists {\n  id\n  qrCodes(first: 100) {\n    edges {\n      node {\n        id\n        ...QrCodeCell_qrCode\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '705d6dd2b121f1e9dccf8705aa7ec3cd';

module.exports = node;
